import http from '../services/http';

export const apiLogin = async (payload) => {
  try {
    const response = await http.post('/auth/login', payload);
    return response.data; // return token or user info
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiLogout = async (fcmToken) => {
  try {
    const response = await http.post('/auth/logout', {
      fcm_token: fcmToken
    });
    return response;
  } catch (error) {
    console.error('Logout API error:', error);
    return null;
  }
};